import tabocaLogo from "@/assets/taboca-logo.png";

const AboutTaboca = () => {
  return (
    <section className="py-16 md:py-24 bg-[hsl(35_90%_97%)]">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <img 
              src={tabocaLogo} 
              alt="Taboca Arquitetura e Cidades" 
              className="h-16 md:h-20 mx-auto mb-6"
            />
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-foreground">
              Quem está por trás do programa?
            </h2>
          </div>

          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-[var(--shadow-card)]">
            <div className="prose prose-lg max-w-none text-muted-foreground space-y-6">
              <p className="text-lg leading-relaxed">
                A <strong className="text-foreground">Taboca Arquitetura e Cidades</strong> é um escritório de arquitetura sediado em Limeira/SP, com atuação há mais de 8 anos em projetos residenciais, comerciais e regularização de imóveis.
              </p>
              
              <p className="text-lg leading-relaxed">
                Nosso propósito é levar arquitetura acessível, técnica e humana a todas as famílias — acreditamos que uma casa bem pensada transforma a vida das pessoas.
              </p>
              
              <p className="text-lg leading-relaxed">
                Com o programa <strong className="text-[hsl(var(--orange-strong))]">Minha Casa Mais Bonita</strong>, ampliamos nossa missão: ajudar famílias de baixa renda a conquistar moradias mais seguras, bonitas e funcionais, com o suporte de profissionais especializados e acompanhamento em todas as etapas.
              </p>
            </div>

            <div className="mt-10 pt-8 border-t border-border">
              <div className="grid md:grid-cols-3 gap-6 text-center">
                <div>
                  <div className="text-3xl font-bold text-[hsl(var(--orange-strong))] mb-2">+8</div>
                  <div className="text-muted-foreground">Anos de experiência</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-[hsl(var(--orange-strong))] mb-2">+200</div>
                  <div className="text-muted-foreground">Projetos realizados</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-[hsl(var(--orange-strong))] mb-2">100%</div>
                  <div className="text-muted-foreground">Comprometimento</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutTaboca;
